export interface ReverseIvrAudioOptionLike {
  id: string;
  name?: string | null;
  displayName?: string | null;
  originalFilename?: string | null;
}

function normalizeString(value: string | null | undefined): string {
  return String(value || '').trim();
}

/**
 * Normalize one Reverse IVR audio option so the UI can rely on consistent
 * display/download labels regardless of the backend payload shape.
 */
export function normalizeReverseIvrAudioOption<T extends ReverseIvrAudioOptionLike>(
  option: T,
): T & { name: string; displayName: string; originalFilename: string | null } {
  const originalFilename = normalizeString(option.originalFilename);
  const fallbackName = normalizeString(option.name);
  const displayName = normalizeString(option.displayName) || fallbackName || originalFilename || option.id;

  return {
    ...option,
    name: displayName,
    displayName,
    originalFilename: originalFilename || fallbackName || null,
  };
}

export function getReverseIvrAudioDisplayName(option: ReverseIvrAudioOptionLike | null | undefined): string {
  if (!option) {
    return '—';
  }
  return normalizeReverseIvrAudioOption(option).displayName;
}

export function getReverseIvrAudioDownloadFilename(
  option: ReverseIvrAudioOptionLike | null | undefined,
): string | undefined {
  if (!option) {
    return undefined;
  }
  const normalized = normalizeReverseIvrAudioOption(option);
  return normalized.originalFilename || normalized.displayName || undefined;
}
